import { render, staticRenderFns } from "./RoleListView.vue?vue&type=template&id=6b0e6008&scoped=true&"
import script from "./RoleListView.vue?vue&type=script&lang=js&"
export * from "./RoleListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e6008",
  null
  
)

export default component.exports